import styles from './styles.css?inline';

export default styles;
